import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {NgClass} from "@angular/common";
import {AddEmployeeFormComponent} from "../../attendance/employees/add-employee-form/add-employee-form.component";
import {FormPopupComponent} from "../../../components";
import {DxButtonComponent, DxDataGridComponent, DxFormComponent, DxTemplateDirective} from "devextreme-angular";
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent, DxoScrollingComponent,
    DxoSearchComponent, DxoSearchPanelComponent, DxoSelectionComponent, DxoSortingComponent, DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {GridPageComponent, FilterConfig} from "../../common/grid-page.component";
import {UserAvatarEmailComponent} from "../../../components/utils/user-avatar-email/user-avatar-email.component";
import {
    CreateEmployeeCommand,
    EmployeesClient, UserStatus, UserGridViewDto, AuthService, PermissionType, AccessType
} from "@services";
import {Router} from "@angular/router";
import EnumUtils from "../../../shared/enum-utils";
import {DxDataGridTypes} from "devextreme-angular/ui/data-grid";
import notify from "devextreme/ui/notify";
import {FormatPhonePipe} from "../../../pipes/format-phone.pipe";

@Component({
    selector: 'app-users',
    imports: [
        DxButtonComponent,
        DxDataGridComponent,
        DxFormComponent,
        DxTemplateDirective,
        DxiColumnComponent,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoFilterRowComponent,
        DxoHeaderFilterComponent,
        DxoLoadPanelComponent,
        DxoPagerComponent,
        DxoPagingComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSearchPanelComponent,
        DxoSelectionComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        FilterPanelComponent,
        FormPopupComponent,
        UserAvatarEmailComponent,
        AddEmployeeFormComponent,
        FormatPhonePipe,
        DxiButtonComponent,
        DxoScrollingComponent,
        NgClass
    ],
    templateUrl: './users.component.html',
    styleUrl: './users.component.scss',
})
export class UsersComponent extends GridPageComponent<UserGridViewDto> implements OnInit {
    @ViewChild(AddEmployeeFormComponent, {static: false}) createNewForm: AddEmployeeFormComponent;

    private employeesClient = inject(EmployeesClient);
    private router = inject(Router);
    protected authService = inject(AuthService);

    constructor() {
        super();
        this.init(UserGridViewDto);
    }

    isAddUserPopupOpened = false;
    userId: string;
    dataSource = this.dataSources.userList();
    roleOptions: { value: string, text: string }[] = [];
    statusOptions = EnumUtils.getEnumOptions(UserStatus);
    protected override exportName: string = "Users";

    protected override filterConfig: FilterConfig[] = [
        { field: 'employee.name', op: 'contains' },
        { field: 'employee.email', op: 'contains' },
        { field: 'mainRole', op: '=' },
        { field: 'address', op: 'contains' },
        { field: 'phone', op: 'contains' },
        { field: 'status', op: '=' },
    ];

    ngOnInit(): void {
        this.dataSources.roleOptions().load().then((data: any) => {
            this.roleOptions = data.map((role: any) => ({value: role.name, text: role.name}));
        });
    }

    addUser() {
        this.isAddUserPopupOpened = true;
    };

    protected getStatusBadgeClass(status: UserStatus): string {
        return EnumUtils.getUserStatusBadgeClass(status);
    }

    isImpersonateVisible = (e: any): boolean => {
        return this.authService.canImpersonate(e.row?.data?.id, e.row?.data?.roles);
    }

    onImpersonateClick = (e: any) => {
        const userId = e.row.data.id;
        this.authService.impersonate(userId).subscribe({
            next: () => {
                window.location.reload();
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg => {
                    notify({
                        message: errMsg.message,
                        type: "error",
                        displayTime: 5000,
                    }, {
                        position: "bottom right",
                        direction: "up-push"
                    });
                }));
            }
        });
    }

    override async onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        const {data} = e;

        this.userId = data.id;
        await this.router.navigate([`/employee/${this.userId}`]);
    }

    onAddEmployeePopupSaveClick = () => {
        let formData = this.createNewForm.getData();

        let createCommand = new CreateEmployeeCommand(formData)
        this.employeesClient.createEmployee(createCommand).subscribe({
            next: async () => {
                this.isAddUserPopupOpened = false;
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg => {
                    notify({
                        message: errMsg.message,
                        type: "error",
                        displayTime: 5000,
                    }, {
                        position: "bottom right",
                        direction: "up-push"
                    });
                }));
            }
        });
    };

    protected readonly PermissionType = PermissionType;
    protected readonly AccessType = AccessType;
}
